import { render, staticRenderFns } from "./sett.vue?vue&type=template&id=59b582ab&scoped=true&"
import script from "./sett.vue?vue&type=script&lang=js&"
export * from "./sett.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b582ab",
  null
  
)

export default component.exports